<script>
import TextEdit from '../common/TextEdit.vue'
import mixin from '../../utils/mixin'
import { transfCssUtil } from '../../utils/index'
export default {
  name: 'AdvanceTabs',
  inheritAttrs: false,
  mixins: [mixin],
  components: {
    TextEdit,
  },
  props: {
    value: {
      type: String,
      default: '',
    },
    mainLogo: {
      type: Object,
      default() {
        return {}
      },
    },
    mainTitle: {
      type: Object,
      default() {
        return {}
      },
    },
    subTitle: {
      type: Object,
      default() {
        return {}
      },
    },
    __childOptionsConfig__: {
      type: Array,
      default() {
        return []
      },
    }
  },
  data() {
    return {
      activeName: '',
    }
  },
  computed: {

    transfCss() {
      return {
        mainLogoWrapper: transfCssUtil(this.mainLogo.wrapperStyle),
        mainLogo: transfCssUtil(this.mainLogo.style),
        mainTitle: this.addGradientColorStyle(transfCssUtil(this.mainTitle.style), this.mainTitle),
        subTitle: this.addGradientColorStyle(transfCssUtil(this.subTitle.style), this.subTitle),
      }
    },
    activeTab () {
      const tabList = this.__childOptionsConfig__ || []
      return tabList.find((item) => item.name === this.value) || {}
    },
  },
  watch: {
    value(newVal) {
      console.log('AdvanceTabs activeName changed', newVal)
    },
  },
  methods: {
    addGradientColorStyle(style, GradientColorConfig) {
      const { isGradient, gradientColor } = GradientColorConfig || {}
      if (isGradient) {
        return {
          ...style,
          backgroundImage: gradientColor,
          color: '#0000',
          'background-clip': 'text',
          '-webkit-background-clip': 'text',
        }
      } else {
        return style
      }
    },
  },
  mounted() {
    // this.activeName = this.$attrs.__config__.defaultValue
    console.log(' this.transfCss', this.transfCss.mainTitle)
  },
  render() {
    console.log('mainTitle', this.mainTitle)

    return (
      <div class="advance-tabs-wrapper">
        {
          this.activeTab.bgImgUrl && (
            <div class="tab-bg" style={this.transfCss.mainLogoWrapper}>
              <img src={this.activeTab.bgImgUrl}></img>
            </div>
          ) 
        }
        {
          this.activeTab.bgVideoUrl && (
            <div class="tab-bg" style={this.transfCss.mainLogoWrapper}>
              <video src={this.activeTab.bgVideoUrl} controls="false" autoplay loop muted poster={ this.activeTab.bgImgUrl}></video>
            </div>
          )
        }
        {
          this.mainLogo.show && (
            <div class="main-logo" style={this.transfCss.mainLogoWrapper}>
              <img src={this.mainLogo.imageUrl} style={this.transfCss.mainLogo}></img>
            </div>
          )
        }
        {
          this.mainTitle.show && (
            <div class="main-title" style={this.transfCss.mainTitle}>
              <TextEdit
                change-key="mainTitle"
                text={this.mainTitle.desc}
                mode={this.textEdit}
                sendData={this.mainTitle}
                {...{ on: this.$listeners }}></TextEdit>
            </div>
          )
        }
        {
          this.subTitle.show && (
            <div class="sub-title" style={this.transfCss.subTitle}>
              <TextEdit
                change-key="subTitle"
                text={this.subTitle.desc}
                mode={this.textEdit}
                sendData={this.subTitle}
                {...{ on: this.$listeners }}></TextEdit>
            </div>
          )
        }
        <el-tabs {...{ attrs: this.$attrs }} {...{ props: this.$props }} {...{ on: this.$listeners }}>
          {this.$slots.default}
        </el-tabs>
      </div>
    )
  },
}
</script>
<style lang="stylus">
.advance-tabs-wrapper {
  position: relative;
  z-index: 1;
  .tab-bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-size: cover;
    background-position: center;
    z-index: -1;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    video {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
}
</style>